import { render, staticRenderFns } from "./questionnaire2022.vue?vue&type=template&id=215270af&scoped=true&"
import script from "./questionnaire2022.vue?vue&type=script&lang=js&"
export * from "./questionnaire2022.vue?vue&type=script&lang=js&"
import style0 from "./questionnaire2022.vue?vue&type=style&index=0&id=215270af&prod&lang=less&scoped=true&"
import style1 from "./questionnaire2022.vue?vue&type=style&index=1&id=215270af&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215270af",
  null
  
)

export default component.exports